/**
 * BANCA certification levels.
 *
 * `Professional.bancaCertificate` is stored as an integer 0-5 and the API
 * keeps receiving that integer — the mobile app is untouched. Only the
 * back-office maps it to a label, because a bare number told an admin nothing
 * about what they were granting.
 *
 * Level 0 means "not certified": the backend derives `isCertified` from
 * `banca_certificate > 0`.
 */
export const CERTIFICATION_LEVELS = {
  NOT_CERTIFIED: 0,
  BEGINNER: 1,
  CONFIRMED: 2,
  COMPETENT: 3,
  EXPERIENCED: 4,
  EXPERT: 5,
};

export const CERTIFICATION_LEVEL_META = {
  0: {
    label: "Non certifié",
    stars: "",
    badgeClass: "badge badge-soft-secondary",
    description: "Le professionnel n'est pas certifié.",
  },
  1: {
    label: "★ Débutant",
    stars: "★",
    badgeClass: "badge badge-soft-warning",
    description: "Compétences de base constatées.",
  },
  2: {
    label: "★★ Confirmé",
    stars: "★★",
    badgeClass: "badge badge-soft-warning",
    description: "Compétences confirmées sur le terrain.",
  },
  3: {
    label: "★★★ Compétent",
    stars: "★★★",
    badgeClass: "badge badge-soft-info",
    description: "Maîtrise reconnue de son domaine.",
  },
  4: {
    label: "★★★★ Expérimenté",
    stars: "★★★★",
    badgeClass: "badge badge-soft-success",
    description: "Expérience étendue et régulièrement sollicitée.",
  },
  5: {
    label: "★★★★★ Expert",
    stars: "★★★★★",
    badgeClass: "badge badge-soft-success",
    description: "Référence dans son domaine.",
  },
};

/** Options for a certification level `<select>`, in ascending order. */
export const CERTIFICATION_LEVEL_OPTIONS = Object.entries(
  CERTIFICATION_LEVEL_META
).map(([value, meta]) => ({
  value: Number(value),
  label: meta.label,
  description: meta.description,
}));

export const getCertificationMeta = (level) => {
  const numeric = Number(level);
  return (
    CERTIFICATION_LEVEL_META[Number.isFinite(numeric) ? numeric : 0] ||
    CERTIFICATION_LEVEL_META[0]
  );
};
